<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Вопросы заданные на сайте</h2>
          <div class="px-3"></div>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <v-list>
          <v-list-item v-for="chat in chats" :href="`/#/support/chats/${chat.chatid}`">
            <v-list-item-avatar>
              <img :src="`https://ui-avatars.com/api/?name=${(chat.title || '').split(' ').slice(0, 2).join('+')}&size=128`">
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{chat.title}}</v-list-item-title>
              <v-list-item-subtitle v-if="chat.lastmsg">
                <span class='text--primary'>
                  <span v-if="chat.lastmsg.operatorid" class="secondary--text">
                    {{getOperator(chat.lastmsg.operatorid).email}}
                  </span>
                  <span v-else></span>
                  <span>{{time(chat.lastmsg.cts)}}</span>
                  &mdash;
                </span>
                <p>{{chat.lastmsg.content}}</p>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon v-if="chat.lastmsg.operatorid">check</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-btn color="primary" @click="loadmore()" :disabled="end">Загрузить ещё</v-btn>
          </v-list-item>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Chats',
  data: () => ({
    chats: [],
    users: [],
    page: 1,
    end: false,
  }),
  methods: {
    async fetch () {
      const { users } = await this.fetchUsers()
      this.users = users
      const { chats } = await this.fetchChats()
      this.chats = chats
    },
    async fetchChats () {
      return this.$store.dispatch('sioRequest', {
        topic: 'fetch-chats',
        pl: {
          page: this.page,
          limit: 20
        }
      })
    },
    async fetchUsers () {
      return this.$store.dispatch('sioRequest', {
        topic: 'fetch-users',
        pl: {
          chatid: this.chatid
        }
      })
    },
    time (ts) {
      return moment(ts).fromNow()
    },
    getOperator (id) {
      return this.users.find(x => x.operatorid === id)
    },
    async loadmore () {
      this.page++
      const { chats } = await this.fetchChats()
      if (chats.length === 0) {
        this.$store.dispatch('snack', 'Конец')
        this.end = true
      } else {
        this.chats = [ ...(this.chats), ...chats ]
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    async chats (val) {
      if (val) {
        setTimeout(async () => {
          const { chats } = await this.fetchChats()
          this.chats = chats
        }, 60000)
      }
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  }
}
</script>

<style lang="css">
</style>
